import React from "react";
import { Button, Dropdown, Menu } from "antd";
import { getJDWJAuthUrl } from "@/services/api/ewaybillAuth";
import { useRequest } from "ahooks";
import { DownOutlined } from "@ant-design/icons";
import { useModalStore } from "@/hooks/Modal/hooks";
import AddJDExpressModal from "./AddJDExpressModal";

interface JDAuthButtonProps {}

enum JD {
  wj = "wj",
  express = "express",
}

const JDAuthButton: React.FC<JDAuthButtonProps> = () => {
  const modalStore = useModalStore();
  const jdwjRequest = useRequest(getJDWJAuthUrl, { manual: true });

  return (
    <Dropdown
      overlay={() => {
        return (
          <Menu
            onClick={async ({ key }) => {
              if (key === JD.wj) {
                const { url } = await jdwjRequest.runAsync();

                window.location.href = url;
              } else if (key === JD.express) {
                modalStore.openModal(AddJDExpressModal);
              }
            }}
          >
            <Menu.Item key={JD.express}>
              <span>授权使用京东物流(京东快递、京东快运、京东大件)</span>
            </Menu.Item>
            <Menu.Item key={JD.wj}>
              <span>授权使用京东无界</span>
            </Menu.Item>
          </Menu>
        );
      }}
    >
      <Button className="mr15 btn-success" loading={jdwjRequest.loading}>
        授权使用京东无界、京东物流电子面单
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default React.memo(JDAuthButton);
